import http from "./http"
import store from './../store/index'
import { delParam } from './tools'

function initShare(actInfo, link) {

	wxShareData({
		title: actInfo.linkTitle || '家居建材活动',
		desc: actInfo.linkDesc || '感恩大回馈！超劲爆价产品低至9.9等你来抢！',
		link: link,
		imgurl: actInfo.linkPoster || 'https://j.weizan.cn/youxiang/icon.png'
	})
}

function wxShareData(shareSide) {
	//分享给朋友
	wx.onMenuShareAppMessage({
		title: shareSide.title, //  分享标题
		desc: shareSide.desc, // 分享描述
		link: shareSide.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl: shareSide.imgurl, // 分享图标
		type: 'link', // 分享类型,music、video或link，不填默认为link
		dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
		success: () => {
			// PromptMsg("分享成功");
		},
		cancel: () => {
			// 用户取消分享后执行的回调函数
		}
	});

	//分享到朋友圈
	wx.onMenuShareTimeline({
		title: shareSide.title, // 分享标题
		link: shareSide.link, // 分享链接
		imgUrl: shareSide.imgurl, // 分享图标
		success: () => {
			// PromptMsg("分享成功");
		},
		cancel: () => {
			// 用户取消分享后执行的回调函数
		}
	});

	wx.showOptionMenu();
}

function handleLink() {

	const act_id = localStorage.getItem('act_id');
	const inviteId = localStorage.getItem('inviteId');
	const shop_id = localStorage.getItem('shop_id');
	const brand_id = localStorage.getItem('brand_id');
	const kpi_user_id = localStorage.getItem('kpi_user_id');
	const share_user_id = localStorage.getItem('user_id');
	const share_user_name = encodeURIComponent(localStorage.getItem('userName'))
	const share_user_avatar = encodeURIComponent(localStorage.getItem('avatarUrl'))

	let link = location.href
	console.log('1', link)
	link = delParam(link, 'code');
	link = delParam(link, 'state');
	link = delParam(link, 'scene');
	link = delParam(link, 'action');
	link = delParam(link, 'self');
	link = delParam(link, 'kpi_user_id')
	link = delParam(link, 'share_user_id')
	link = delParam(link, 'brand_id')
	link = delParam(link, 'inviteId')
	link = delParam(link, 'shop_id')
	link = delParam(link, 'share_user_name')
	link = delParam(link, 'act_id')
	console.log('2', link);
	if (link.indexOf('?') !== -1 && link.indexOf('?') !== location.origin.length + 1) {
		link = link + '&act_id=' + act_id
	} else {
		link = link + '?act_id=' + act_id
	}
	if (kpi_user_id) {
		link += '&kpi_user_id=' + kpi_user_id;
	}
	if (share_user_id) {
		link += '&share_user_id=' + share_user_id;
	}
	if (inviteId) {
		link += '&inviteId=' + inviteId;
	}
	if (shop_id) {
		link += '&shop_id=' + shop_id;
	}
	if (brand_id) {
		link += '&brand_id=' + brand_id;
	}
	if (share_user_name) {
		link += '&share_user_name=' + share_user_name;
	}
	if (share_user_avatar) {
		link += '&share_user_avatar=' + share_user_avatar;
	}
	return link
}


export function InitWXSDK(options, onReady, shareParams) {
	let URL = window.entryUrl ? window.entryUrl : location.href
	console.log(location.href);
	let actInfo = {}
	console.log('URL', URL)
	console.log('entryUrl', window.entryUrl)
	http.post('/v1/wechat/jsconfig/get', {
		url: URL
	}).then(async (config) => {
		console.log(shareParams);
		if (shareParams?.isSeckill) {
			actInfo.data = JSON.parse(shareParams.shareInfo.data)
		} else {
			actInfo = await http.post('/v1/home/activity')
			store.commit('setActShareData', actInfo.data)
			// TODO 二期切换sessionStorage时需将此缓存去除
			// if (!store.state.actShareData) {
			// 	actInfo = await http.post('/v1/home/activity')
			// 	store.commit('setActShareData', actInfo.data)
			// } else {
			// 	actInfo.data = store.state.actShareData
			// }

		}
		console.log('share', actInfo.data)
		Object.assign(config.data, options)
		signWXSDK(config.data, onReady, actInfo.data, handleLink())
	})


}

function signWXSDK(config, onReady, actInfo, link) {
	wx.config({
		debug: false,
		appId: config.appId,
		timestamp: config.timestamp,
		nonceStr: config.nonceStr,
		signature: config.signature,
		jsApiList: [
			"checkJsApi",
			"onMenuShareTimeline",
			"onMenuShareAppMessage",
			"hideMenuItems",
			"showMenuItems",
			"hideAllNonBaseMenuItem",
			"showAllNonBaseMenuItem",
			"translateVoice",
			"startRecord",
			"stopRecord",
			"onRecordEnd",
			"playVoice",
			"pauseVoice",
			"stopVoice",
			"uploadVoice",
			"downloadVoice",
			"chooseImage",
			"previewImage",
			"uploadImage",
			"downloadImage",
			"getNetworkType",
			"openLocation",
			"getLocation",
			"hideOptionMenu",
			"showOptionMenu",
			"closeWindow",
			"scanQRCode",
			"chooseWXPay",
			"openProductSpecificView",
			"addCard",
			"chooseCard",
			"openCard",
			"openAddress",
		]
	});
	wx.ready(() => {
		initShare(actInfo, link)
		console.log(link);
		if (!config.openShare) {
			wx.hideMenuItems({
				menuList: ["menuItem:share:timeline", 'menuItem:share:appMessage', 'menuItem:share:qq', "menuItem:share:QZone", "menuItem:copyUrl"]
			});
		} else {
			if(config.openShareTimeline){
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq', "menuItem:share:QZone", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:openWithQQBrowser", "menuItem:copyUrl"]
				});
			}else{
				wx.hideMenuItems({
					menuList: ["menuItem:share:timeline", 'menuItem:share:qq', "menuItem:share:QZone", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:openWithQQBrowser", "menuItem:copyUrl"]
				});
			}
		}
		onReady && onReady();
	});
	wx.error((error) => {
		console.log('WX SDk loaded failed', error);
	});
}


